var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 579.9 355.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "textual",
    d: "M32.7 312.9V281h11c2.5 0 4.4.2 5.7.5 1.8.4 3.4 1.2 4.7 2.3 1.7 1.4 2.9 3.2 3.8 5.4.8 2.2 1.3 4.7 1.3 7.6 0 2.4-.3 4.6-.8 6.4-.6 1.9-1.3 3.4-2.2 4.6-.9 1.2-1.9 2.2-2.9 2.9-1.1.7-2.3 1.2-3.8 1.6-1.5.4-3.2.5-5.1.5H32.7zm4.2-3.7h6.8c2.1 0 3.8-.2 4.9-.6 1.2-.4 2.1-.9 2.9-1.7 1-1 1.8-2.3 2.3-4 .6-1.7.8-3.7.8-6.1 0-3.3-.5-5.9-1.6-7.7-1.1-1.8-2.4-3-4-3.6-1.1-.4-3-.7-5.5-.7h-6.7v24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "textual",
    d: "M88.3 312.9V281h23.1v3.8H92.5v9.8h17.6v3.7H92.5v10.9h19.6v3.8H88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "textual",
    d: "M141.1 312.9V281h12c2.4 0 4.4.3 5.9 1 1.5.6 2.6 1.6 3.5 3 .8 1.3 1.3 2.7 1.3 4.2 0 1.4-.4 2.6-1.1 3.9-.7 1.2-1.9 2.2-3.3 2.9 1.9.6 3.4 1.5 4.4 2.9 1 1.4 1.6 3 1.6 4.8 0 1.5-.3 2.9-.9 4.2-.6 1.3-1.4 2.3-2.3 3-.9.7-2.1 1.2-3.5 1.6-1.4.4-3.1.5-5.1.5h-12.5zm4.3-18.5h6.9c1.9 0 3.2-.1 4-.4 1.1-.3 1.9-.8 2.4-1.6.5-.7.8-1.7.8-2.8 0-1.1-.3-2-.8-2.8-.5-.8-1.2-1.4-2.2-1.7-.9-.3-2.6-.4-4.8-.4h-6.4v9.7zm0 14.8h7.9c1.4 0 2.3-.1 2.9-.2 1-.2 1.8-.5 2.4-.9.7-.4 1.2-1 1.6-1.8.4-.8.6-1.7.6-2.7 0-1.2-.3-2.2-.9-3.1-.6-.9-1.5-1.5-2.5-1.8-1.1-.4-2.6-.5-4.7-.5h-7.4v11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "textual",
    d: "M202.5 312.9v-28.1H192V281h25.3v3.8h-10.5v28.1h-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "textual",
    d: "M280 312.9V281h14.1c2.8 0 5 .3 6.5.9 1.5.6 2.7 1.6 3.5 3 .9 1.5 1.3 3.1 1.3 4.8 0 2.3-.7 4.2-2.2 5.7-1.5 1.6-3.7 2.5-6.8 3 1.1.5 2 1.1 2.5 1.6 1.2 1.1 2.4 2.5 3.5 4.2l5.5 8.7h-5.3l-4.2-6.6c-1.2-1.9-2.2-3.4-3-4.4-.8-1-1.5-1.7-2.1-2.1-.6-.4-1.3-.7-1.9-.8-.5-.1-1.3-.2-2.3-.2h-4.9V313H280zm4.2-17.8h9.1c1.9 0 3.4-.2 4.5-.6 1.1-.4 1.9-1 2.5-1.9.6-.9.8-1.8.8-2.9 0-1.5-.5-2.7-1.6-3.7s-2.8-1.5-5.2-1.5h-10.1v10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "textual",
    d: "M335.5 312.9V281h23.1v3.8h-18.8v9.8h17.6v3.7h-17.6v10.9h19.6v3.8h-23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "textual",
    d: "M388.4 312.9V281h4.2v28.1h15.7v3.8h-19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "textual",
    d: "M437.4 312.9V281h4.2v31.9h-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "textual",
    d: "M472.5 312.9V281h23.1v3.8h-18.8v9.8h17.6v3.7h-17.6v10.9h19.6v3.8h-23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "textual",
    d: "M525.7 312.9V281h21.5v3.8h-17.3v9.9h15v3.8h-15V313h-4.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "textual",
    d: "M32.7 191.8h6c0-8.9.2-14.1.4-15.8.5-3.7 2-6.7 4.7-8.9s6.5-3.3 11.3-3.3c3.5 0 7.5.8 11.9 2.5v13.2c-2.5-.7-4.5-1-6.1-1-2 0-3.5.4-4.4 1.2-.7.6-1 1.9-1 3.8l-.1 8.3h10.8v14.5H55.8v53.5h-17v-53.5h-6v-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "textual",
    d: "M77.4 191.8h14.8v8.6c1.5-3.4 3.6-5.9 6.2-7.7 2.6-1.7 5.4-2.6 8.5-2.6 2.2 0 4.4.6 6.8 1.8l-5.2 14.7c-2-1-3.6-1.5-4.9-1.5-2.6 0-4.8 1.6-6.6 4.9-1.8 3.2-2.7 9.6-2.7 19.1l.1 3.3v27.4h-17v-68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "textual",
    d: "M185.8 227.4c0-11.2-3.4-20.2-10.1-27-6.7-6.8-15.4-10.2-26.1-10.2-10.1 0-18.5 3.4-25.2 10.2-6.7 6.8-10 15.4-10 25.8 0 10.1 3.3 18.5 10 25.2 6.7 6.7 15.4 10.1 26 10.1 6.9 0 12.8-1.2 17.8-3.6 5-2.4 9.3-6.2 12.9-11.3l-14.4-6.7c-4.6 4.5-10.1 6.7-16.4 6.7-5.3 0-9.7-1.4-13.1-4.3-3.4-2.8-5.5-6.7-6.3-11.5h54.9v-3.4zm-54.3-10.1c1.9-4.1 4-7 6.3-8.7 3.6-2.6 7.8-3.9 12.6-3.9 4.4 0 8.3 1.2 11.7 3.5 3.3 2.3 5.6 5.4 6.7 9.1h-37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "textual",
    d: "M267.7 227.4c0-11.2-3.4-20.2-10.1-27-6.7-6.8-15.4-10.2-26.1-10.2-10.1 0-18.5 3.4-25.2 10.2-6.7 6.8-10 15.4-10 25.8 0 10.1 3.3 18.5 10 25.2 6.7 6.7 15.4 10.1 26 10.1 6.9 0 12.8-1.2 17.8-3.6 5-2.4 9.3-6.2 12.9-11.3l-14.4-6.7c-4.6 4.5-10.1 6.7-16.4 6.7-5.3 0-9.7-1.4-13.1-4.3-3.4-2.8-5.5-6.7-6.3-11.5h54.9v-3.4zm-54.3-10.1c1.9-4.1 4-7 6.3-8.7 3.6-2.6 7.8-3.9 12.6-3.9 4.4 0 8.3 1.2 11.6 3.5 3.3 2.3 5.6 5.4 6.7 9.1h-37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "textual",
    d: "M331.6 199.3c-3-3.1-6.4-5.4-9.9-6.9-3.6-1.5-7.4-2.3-11.5-2.3-8.9 0-16.4 3.3-22.7 10-6.2 6.7-9.3 15.3-9.3 25.7 0 10.1 3.2 18.5 9.6 25.3 6.4 6.8 14 10.2 22.9 10.2 3.9 0 7.6-.7 10.9-2.1 3.3-1.4 6.7-3.7 10-6.8v7.2h17v-94.1h-17v33.8zm-4.6 11.9c3.5 3.7 5.3 8.4 5.3 14.4s-1.8 10.9-5.3 14.6c-3.5 3.7-8 5.6-13.4 5.6-5.2 0-9.6-1.9-13.1-5.7-3.6-3.8-5.3-8.6-5.3-14.5 0-5.8 1.7-10.6 5.2-14.3 3.5-3.7 7.9-5.6 13.2-5.6 5.4 0 9.8 1.9 13.4 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "textual",
    d: "M371.8 199.3c-7.8 7-11.7 15.9-11.7 26.5 0 9.9 3.4 18.3 10.3 25.2 6.9 6.9 15.2 10.4 24.9 10.4 6.6 0 12.6-1.6 18.1-4.7 5.5-3.1 9.8-7.5 13-13 3.2-5.6 4.8-11.6 4.8-18 0-6.3-1.6-12.3-4.7-17.7-3.2-5.5-7.6-9.8-13.2-13-5.6-3.2-11.6-4.8-18-4.8-8.8-.1-16.7 3-23.5 9.1m37.1 12.2c3.5 3.6 5.2 8.4 5.2 14.2 0 5.8-1.8 10.6-5.3 14.3-3.5 3.7-8 5.6-13.3 5.6-5.3 0-9.7-1.8-13.2-5.5s-5.2-8.4-5.2-14.4c0-5.7 1.8-10.4 5.3-14.1 3.5-3.7 7.9-5.5 13.2-5.5 5.4 0 9.9 1.8 13.3 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "textual",
    d: "M442.9 191.8h17v7.9c2.9-3.2 6.2-5.6 9.8-7.2 3.6-1.6 7.5-2.4 11.7-2.4 4.3 0 8.1 1.1 11.5 3.2 3.4 2.1 6.2 5.2 8.3 9.2 2.7-4 6.1-7.1 10-9.2 4-2.1 8.3-3.2 13-3.2 4.9 0 9.1 1.1 12.8 3.4 3.7 2.2 6.3 5.2 7.9 8.8 1.6 3.6 2.4 9.5 2.4 17.6v39.8h-17v-34.3c0-7.7-1-12.9-2.9-15.6-1.9-2.7-4.9-4.1-8.7-4.1-3 0-5.6.8-8 2.5-2.3 1.7-4.1 4-5.2 6.9-1.1 2.9-1.7 7.6-1.7 14.1v30.5h-17v-32.8c0-6-.5-10.4-1.4-13.2-.9-2.7-2.3-4.7-4.1-6.1-1.8-1.3-4-2-6.6-2-2.9 0-5.5.8-7.8 2.5s-4.1 4-5.3 7.1c-1.2 3-1.8 7.8-1.8 14.3v30.1h-17v-67.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "sun-ray",
    d: "M64.2 140.2l66 27.8c1.7-4.6 3.7-9 5.9-13.1l-71.9-14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "sun-ray",
    d: "M195.1 106.1c.2 0 .4-.1.6-.1l-28.6-70.6 14.7 75.1c4.1-1.8 8.3-3.2 12.6-4.3l.7-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "sun-ray",
    d: "M178.6 112c.8-.4 1.5-.7 2.3-1.1l-41.7-63.8 28.9 70.9c3.2-2.2 6.5-4.1 9.9-5.8l.6-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "sun-ray",
    d: "M163.3 121.6c1.3-1 2.6-1.9 3.9-2.9L114 64.3l41.9 63.7c2.2-2.1 4.5-4.1 6.8-6l.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "sun-ray",
    d: "M149.9 134.4c1.7-2 3.5-3.8 5.3-5.6L92.6 86.1l52.9 53.8c1.2-1.7 2.5-3.3 3.8-4.8l.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "sun-ray",
    d: "M278.4 139.8l52.8-53.7-62.5 42.6c-.2-.3-.5-.5-.8-.8l41.8-63.6-53.2 54.3c-.3-.2-.6-.4-.8-.6l28.9-70.9-41.7 63.7c-.3-.2-.7-.3-1-.4l14.7-75.1-28.6 70.5c-.4-.1-.8-.2-1.1-.3l.1-76.3-14.5 74.7H212.2c5.6.1 11.1.8 16.4 2l.7.1c5.5 1.3 10.7 3.3 15.8 5.7l.6.3c5.1 2.5 10 5.7 14.6 9.3l.6.5c4.6 3.7 8.9 7.8 12.8 12.4l.6.7c3.9 4.6 7.5 9.7 10.6 15l.5.9c.4.7.8 1.5 1.2 2.2l.1-.1 61-41.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "sun-ray",
    d: "M144.7 140.9l-68.9-29.2 61.1 41.5c.4-.7.8-1.5 1.2-2.2l.5-.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "sun-ray",
    d: "M196.7 29.4l.1 76.3c4.7-1 9.5-1.5 14.5-1.6l-14.6-74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "sun-ray",
    d: "M359.6 140.2l-71.7 14.6h-.1c2.2 4.3 4.2 8.7 5.9 13.3h-.7v.1l.1-.1h.7c0-.1-.1-.2-.1-.2l65.9-27.7z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a4b5f73f.svg";
export { ForwardRef as ReactComponent };